/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-namespace */

/**
 * Cloudflare Calls API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

/**
 *
 * @export
 * @interface CloseTrackObject
 */
export interface CloseTrackObject {
  /**
   * mid associated to the track's transceiver to close
   * @type {string}
   * @memberof CloseTrackObject
   */
  mid?: string;
}
/**
 *
 * @export
 * @interface CloseTracksRequest
 */
export interface CloseTracksRequest {
  /**
   *
   * @type {SessionDescription}
   * @memberof CloseTracksRequest
   */
  sessionDescription?: SessionDescription;
  /**
   *
   * @type {Array<CloseTrackObject>}
   * @memberof CloseTracksRequest
   */
  tracks?: Array<CloseTrackObject>;
  /**
   * True if you want to stop just the data flow for the tracks, no WebRTC renegotiation
   * @type {boolean}
   * @memberof CloseTracksRequest
   */
  force?: boolean;
}
/**
 *
 * @export
 * @interface CloseTracksResponse
 */
export interface CloseTracksResponse {
  /**
   *
   * @type {SessionDescription}
   * @memberof CloseTracksResponse
   */
  sessionDescription?: SessionDescription;
  /**
   *
   * @type {Array<CloseTrackObject & any>}
   * @memberof CloseTracksResponse
   */
  tracks?: Array<CloseTrackObject & any>;
  /**
   *
   * @type {boolean}
   * @memberof CloseTracksResponse
   */
  requiresImmediateRenegotiation?: boolean;
}
/**
 *
 * @export
 * @interface GetSessionStateResponse
 */
export interface GetSessionStateResponse {
  /**
   *
   * @type {Array<TrackObject & any>}
   * @memberof GetSessionStateResponse
   */
  tracks?: Array<TrackObject & any>;
}
/**
 *
 * @export
 * @interface InlineResponse201
 */
export interface InlineResponse201 extends NewSessionResponse {}
/**
 *
 * @export
 * @interface NewSessionRequest
 */
export interface NewSessionRequest {
  /**
   *
   * @type {SessionDescription}
   * @memberof NewSessionRequest
   */
  sessionDescription?: SessionDescription;
}
/**
 *
 * @export
 * @interface NewSessionResponse
 */
export interface NewSessionResponse {
  /**
   *
   * @type {NewSessionResponseSessionDescription}
   * @memberof NewSessionResponse
   */
  sessionDescription?: NewSessionResponseSessionDescription;
  /**
   *
   * @type {string}
   * @memberof NewSessionResponse
   */
  sessionId?: string;
}
/**
 *
 * @export
 * @interface NewSessionResponseSessionDescription
 */
export interface NewSessionResponseSessionDescription {
  /**
   *
   * @type {string}
   * @memberof NewSessionResponseSessionDescription
   */
  sdp?: string;
  /**
   *
   * @type {string}
   * @memberof NewSessionResponseSessionDescription
   */
  type?: NewSessionResponseSessionDescription.TypeEnum;
}

/**
 * @export
 * @namespace NewSessionResponseSessionDescription
 */
export namespace NewSessionResponseSessionDescription {
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    Answer = <any>"answer",
    Offer = <any>"offer",
  }
}
/**
 *
 * @export
 * @interface SessionDescription
 */
export interface SessionDescription {
  /**
   *
   * @type {string}
   * @memberof SessionDescription
   */
  sdp?: string;
  /**
   *
   * @type {string}
   * @memberof SessionDescription
   */
  type?: SessionDescription.Type;
}

/**
 * @export
 * @namespace SessionDescription
 */
export namespace SessionDescription {
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    Answer = <any>"answer",
    Offer = <any>"offer",
  }
  export type Type = "answer" | "offer" | "pranswer" | "rollback";
}
/**
 *
 * @export
 * @interface SessionIdRenegotiateBody
 */
export interface SessionIdRenegotiateBody {
  /**
   *
   * @type {SessionDescription}
   * @memberof SessionIdRenegotiateBody
   */
  sessionDescription?: SessionDescription;
}
/**
 *
 * @export
 * @interface SessionsNewBody
 */
export interface SessionsNewBody extends NewSessionRequest {}
/**
 *
 * @export
 * @interface TrackObject
 */
export interface TrackObject {
  /**
   * If you want to share a track, it should be local. If you want to play a track shared by a remote agent, it should be remote
   * @type {string}
   * @memberof TrackObject
   */
  location?: TrackObject.LocationEnum;
  /**
   * mid associated to track's transceiver. It should be set with local tracks only
   * @type {string}
   * @memberof TrackObject
   */
  mid?: string;
  /**
   * Session ID of the track owner. It should be set for remote tracks only
   * @type {string}
   * @memberof TrackObject
   */
  sessionId?: string;
  /**
   * Given name for the track
   * @type {string}
   * @memberof TrackObject
   */
  trackName?: string;
}

/**
 * @export
 * @namespace TrackObject
 */
export namespace TrackObject {
  /**
   * @export
   * @enum {string}
   */
  export enum LocationEnum {
    Local = <any>"local",
    Remote = <any>"remote",
  }
}
/**
 *
 * @export
 * @interface TracksCloseBody
 */
export interface TracksCloseBody extends CloseTracksRequest {}
/**
 *
 * @export
 * @interface TracksRequest
 */
export interface TracksRequest {
  /**
   *
   * @type {SessionDescription}
   * @memberof TracksRequest
   */
  sessionDescription?: SessionDescription;
  /**
   *
   * @type {Array<TrackObject>}
   * @memberof TracksRequest
   */
  tracks?: Array<TrackObject>;
}
/**
 *
 * @export
 * @interface TracksResponse
 */
export interface TracksResponse {
  /**
   *
   * @type {boolean}
   * @memberof TracksResponse
   */
  requiresImmediateRenegotiation?: boolean;
  /**
   *
   * @type {SessionDescription}
   * @memberof TracksResponse
   */
  sessionDescription?: SessionDescription;
  /**
   *
   * @type {Array<TrackObject & any>}
   * @memberof TracksResponse
   */
  tracks?: Array<TrackObject & any>;
}
